import React from "react";
import { Box, Grid, Typography, Button, Stack } from "@mui/material";

const AboutMe = () => {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const calculateExperience = () => {
    const startDate = new Date('2024-08-08');
    const currentDate = new Date();
    const diffTime = currentDate - startDate;
    const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25);
    return diffYears.toFixed(1);
  };
  return (
    <Box
      component="section"
      id="aboutme"
      sx={{
        backgroundColor: "background.paper",
        px: { xs: 2, md: 8 },
        py: { xs: 8, md: 12 },
      }}
    >
      <Grid
        container
        spacing={6}
        alignItems="center"
        justifyContent="space-around"
        direction={{ xs: "column", md: "row" }}
      >
        {/* Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src="./images/Photo.png"
            alt="Pratik"
            sx={{
              width: "100%",
              maxWidth: { xs: 280, sm: 350, md: 400 },
              borderRadius: 2,
              boxShadow: 3,
            }}
          />
        </Grid>

        {/* Text Content */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ maxWidth: 600, textAlign: { xs: "justify", md: "left" } }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              mb: 2,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            About Me
          </Typography>
          <Typography
            sx={{
              color: "text.secondary",
              fontSize: { xs: "1rem", md: "1.1rem" },
              mb: 3,
              lineHeight: 1.7,

              wordBreak: "break-word",
            }}
          >
            Assistant System Engineer at TCS with {calculateExperience()} years of experience
            building full-stack applications using React, Node.js, Express, and
            PostgreSQL. Currently working on an enterprise dashboard application
            for managing and tracking expenses, costs, revenue, and other
            business metrics with complex business logic. Previously interned at
            Refast Technologies, where I contributed to a financial mobile
            application using React Native and MongoDB. Passionate about
            building scalable web applications and continuously improving my
            skills in modern full-stack development.
          </Typography>

          <Stack
            direction="row"
            spacing={2}
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <Button
              size="small"
              variant="outlined"
              sx={{
                px: 2,
                py: 1,
                textTransform: "none",
                fontSize: "1rem",
                borderRadius: 8,
              }}
              onClick={() => handleScroll("contact")}
            >
              Contact Me
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutMe;
